// sessionStorage keys shared across features that live in more than one
// file, so a future rename can't silently desync the reader/writer sides.

// Written by AcceptInvite.tsx when an unauthenticated visitor opens an
// invite link, read (and cleared) by Login.tsx to resume the invite-accept
// flow once they've signed in. See AcceptInvite.tsx/Login.tsx for the full
// lifecycle and cleanup guarantees.
export const PENDING_INVITE_TOKEN_KEY = 'pendingInviteToken'
